import { helpers } from 'mixins/bookings'

export default {
  mixins: [helpers],

  computed: {
    booking () {
      return this.event.booking
    },

    eventDescription () {
      let currency = this.$options.filters.currency
      var budget = ''

      if (this.bookingBudget) {
        if (this.$userIsManager || this.$userIsAdmin) {
          budget = currency(this.bookingBudget, this.booking.currency) + ` per ${this.$starLabel}`
        } else {
          budget = currency(this.bookingBudget, this.booking.currency)
        }
      } else {
        budget = 'Budget TBC'
      }

      if (this.$userIsManager) {
        return `${this.booking.name} – ${this.eventStatusDescription} – ${budget} – ${this.bookingTalentNames}`
      }

      if (this.$userIsAdmin && this.eventStatus === 'booked') {
        return `${this.booking.name} – ${this.eventStatusDescription} – ${budget} – ${this.bookingBookedTalentNames}`
      }

      return `${this.booking.name} – ${this.eventStatusDescription} – ${budget}`
    },

    eventStatusDescription () {
      if (this.eventStatus === 'potential') {
        return 'Awaiting Talent Response'
      } else if (this.eventStatus === 'pending') {
        return this.$activeClientModuleEnabled ? 'Awaiting Client Response' : 'Awaiting Agent Response'
      } else if (this.eventStatus === 'booked') {
        return 'Booked'
      }
    },

    eventStatusClass () {
      return `event-${this.eventStatus}`
    },

    eventStatus () {
      if (this.bookingIsPending) {
        return this.booking.talent.some(({ response }) => response.status === 'applied' && response.client_accepted === false)
          ? 'pending'
          : 'potential'
      } else if (this.bookingIsContextuallyCancelled || this.bookingIsWithdrawn) {
        return 'cancelled'
      } else if (this.bookingTypeIsBooking) {
        return 'booked'
      } else {
        return 'pending'
      }
    },

    eventStartTime () {
      return this.event.start.format('HH:mm')
    },

    eventRouterLink () {
      if (this.bookingTypeIsBooking) {
        return { name: 'bookings.show', params: { id: this.booking.id } }
      }

      return { name: 'requests.show', params: { id: this.booking.id } }
    }
  }
}
